var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuernsey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14.008,
    viewBox: "0 0 20 14.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.65,70.108h-19.3a.358.358,0,0,1-.346-.37V56.47a.358.358,0,0,1,.346-.37H46.654a.358.358,0,0,1,.346.37V69.738A.364.364,0,0,1,46.65,70.108Z",
    transform: "translate(-27 -56.1)",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47,61.632H38.375V56.1H35.621v5.532H27v2.944h8.621v5.532h2.754V64.576H47Z",
    transform: "translate(-27 -56.1)",
    fill: "#ff4b55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.577 2.583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.042,192.113V189.9l-.551.555h-7.74l-.551-.555v2.213l.551-.555h7.74Z",
    transform: "translate(-169.2 -186.585)",
    fill: "#ffe15a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.4,123.542h2.213l-.555-.551v-7.74l.555-.551H244.4l.555.551v7.74Z",
    transform: "translate(-241.085 -114.7)",
    fill: "#ffe15a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuernsey);
export default __webpack_public_path__ + "static/media/guernsey.56fcc0de583f80abba65a190fd5a763f.svg";
export { ForwardRef as ReactComponent };